"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTippy = require("react-tippy");
var FilterButton = function FilterButton(_ref) {
  var handleOnClick = _ref.handleOnClick,
    text = _ref.text,
    active = _ref.active,
    color = _ref.color,
    tooltip = _ref.tooltip,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-button-container flex"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "filter-button",
    type: "button",
    onClick: handleOnClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-checkbox ".concat(active ? 'active' : null)
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "448",
    height: "448",
    viewBox: "0 0 448 448"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    d: "M417.75 141.5c0 6.25-2.5 12.5-7 17l-215 215c-4.5 4.5-10.75 7-17 7s-12.5-2.5-17-7l-124.5-124.5c-4.5-4.5-7-10.75-7-17s2.5-12.5 7-17l34-34c4.5-4.5 10.75-7 17-7s12.5 2.5 17 7l73.5 73.75 164-164.25c4.5-4.5 10.75-7 17-7s12.5 2.5 17 7l34 34c4.5 4.5 7 10.75 7 17z"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "filter-button__wrapper v-align",
    style: {
      backgroundColor: color
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, text), tooltip && !isMobile && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    html: /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb00"
    }, tooltip),
    position: "top",
    trigger: "mouseenter",
    theme: "light",
    arrow: true,
    style: {
      background: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml05"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons white-font m-font"
  }, "info"))))), tooltip && isMobile && /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    html: /*#__PURE__*/_react["default"].createElement("p", {
      className: "mb00"
    }, tooltip),
    position: "top",
    trigger: "mouseenter",
    theme: "light",
    arrow: true,
    style: {
      background: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml05"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons m-font gray-font mt10"
  }, "info"))));
};
FilterButton.propTypes = {
  handleOnClick: _propTypes["default"].func.isRequired,
  text: _propTypes["default"].string,
  active: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  tooltip: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool
};
FilterButton.defaultProps = {
  tooltip: null,
  isMobile: false
};
var _default = exports["default"] = FilterButton;